"use strict";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

(function () {
  "use strict";

  angular.module("insurerContracts").controller("InsurerContractCtrl", InsurerContractCtrl);

  function InsurerContractCtrl($rootScope, $scope, $controller, $timeout, FormlyService, InsurerContractsService, CustomersService, params) {
    var _this = this;

    var vm = this;
    vm.ctrlName = "InsurerContractCtrl";

    vm.log = debug("pages:insurerContract");

    vm.createFields = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var customer;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return localforage.getItem("oneAtATime");

            case 2:
              vm.oneAtATime = _context.sent;
              _context.next = 5;
              return CustomersService.findById({
                _id: $rootScope.$selectedCustomerId.replace("$", "")
              });

            case 5:
              customer = _context.sent;


              if ("$" + vm.model._id === customer.defaultInsurerContract) {
                vm.model.isDefaultContract = true;
              } else {
                vm.model.isDefaultContract = false;
              }

              vm.rows = [{
                columns: [{
                  class: "col-xs-12 col-sm-6 col-md-6",
                  boxes: [{
                    mainTitle: "Informations",
                    fields: [FormlyService.bool("isDefaultContract", "Contrat par défaut", false, { className: "col-xs-12 col-sm-6" }), FormlyService.text("name", "Référence", true, {
                      className: "col-xs-12 col-sm-6"
                    }), FormlyService.date("subscriptionDate", "Date de la souscription", false, { className: "col-xs-12 col-sm-6" }), FormlyService.date("expirationDate", "Date de fin", false, {
                      className: "col-xs-12 col-sm-6"
                    }), FormlyService.textArea("note", "Autres infos", "...", false, {
                      className: "col-xs-12 col-sm-12"
                    })]
                  }, {
                    mainTitle: "Assurance",
                    fields: [FormlyService.text("company", "Nom de l'assurance", false, {
                      className: "col-xs-12 col-sm-6"
                    }), FormlyService.text("contactName", "Nom du contact (assurance)", false, { className: "col-xs-12 col-sm-6" }), FormlyService.text("contactEmail", "Email du contact (assurance)", false, { className: "col-xs-12 col-sm-6" }), FormlyService.text("contactPhone", "Téléphone du contact (assurance)", false, { className: "col-xs-12 col-sm-6" })]
                  }, {
                    mainTitle: "Courtier",
                    fields: [FormlyService.text("brokerCompany", "Nom du courtier", false, { className: "col-xs-12 col-sm-6" }), FormlyService.text("brokerContactName", "Nom du contact (courtier)", false, { className: "col-xs-12 col-sm-6" }), FormlyService.text("brokerContactEmail", "Email du contact (courtier)", false, { className: "col-xs-12 col-sm-6" }), FormlyService.text("brokerContactPhone", "Téléphone du contact (courtier)", false, { className: "col-xs-12 col-sm-6" })]
                  }]
                }, {
                  class: "col-xs-12 col-sm-6 col-md-6",
                  boxes: [{
                    mainTitle: "Franchise",
                    fields: [FormlyService.number("deductibleAmount", "Franchise", false, { className: "col-xs-12 col-sm-6" }), FormlyService.date("deductibleStartDate", "Date de changement de la franchise", false, { className: "col-xs-12 col-sm-6" })]
                  }, {
                    mainTitle: "Transmission",
                    fields: [FormlyService.text("insurerEdiEmail", "Email à utiliser pour la transmission d'un sinistre", true, { className: "col-xs-12 col-sm-12" }), FormlyService.bool("insurerEdiDocsAsLink", "Transformer les pièces jointes en miniatures pour diminuer la taille de l'email", true, { className: "col-xs-12 col-sm-12" })]
                  }, {
                    mainTitle: "Documents à transmettre",
                    fields: [FormlyService.insurerDocs("insurerEdiMandatoryDocs", "", false, {
                      className: "col-xs-12 col-sm-12 col-md-12"
                    })]
                  }]
                }]
              }];

              $timeout(function () {}, 0);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    vm.check = function () {
      console.log("before vm.model", vm.model);

      if (vm.model.insurerEdiMandatoryDocs) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = Object.keys(vm.model.insurerEdiMandatoryDocs)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var type = _step.value;

            console.log("type=", type);
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = Object.keys(vm.model.insurerEdiMandatoryDocs[type])[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var doc = _step2.value;

                console.log("doc=", doc);
                if (vm.model.insurerEdiMandatoryDocs[type][doc]["copy"] == false) {
                  console.log("delete");
                  delete vm.model.insurerEdiMandatoryDocs[type][doc];
                }
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      if (!vm.model.insurerEdiDocsAsLink) {
        vm.model.insurerEdiDocsAsLink = false;
      }

      console.log("after vm.model", vm.model);

      var save = true;

      if (vm.model.contactEmail && !vm.validateEmail(vm.model.contactEmail)) {
        save = false;
        Notiflix.Notify.failure("Le format de l'email de contact n'est pas correct.");
      }

      if (vm.model.insurerEdiEmail) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = vm.model.insurerEdiEmail.split(",")[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var email = _step3.value;

            if (!vm.validateEmail(email)) {
              save = false;
              Notiflix.Notify.failure("Le format d'un des email à utiliser pour la transmission numérique d'un sinistre n'est pas correct.");
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }

      if (save) {
        vm.save();
      }
    };

    vm.validateEmail = function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    };

    vm.ready = function () {
      vm.createFields();
    };

    $controller("CreateBaseController", {
      vm: vm,
      $scope: $scope,
      service: InsurerContractsService,
      listPage: "insurerContracts",
      nameModel: "un contrat",
      params: params
    });
  }
})();